import React from 'react';
import {StyleSheet} from 'react-native';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../../context/salesman';
import InternalTemplate from '../../../../../../components/templates/internal';
import {StackParamList} from '../../../../../../navigators';

import {LogisticForm} from './forms/LogisticForm';
import {
  ILogisticClient,
  ISalesmanClient,
} from '../../../../../../interfaces/dtos/salesman-client.interface';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'AddClientStep2Screen'
>;

export const AddClientStep2Screen = ({navigation}: ScreenProps) => {
  const {setSalesmanNewClientRequest, salesmanNewClientRequest} =
    useSalesmanContext();

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleOnSubmit = (data: ILogisticClient) => {
    setSalesmanNewClientRequest({
      ...salesmanNewClientRequest,
      ...data,
    } as ISalesmanClient);
    navigation.navigate('AddClientStep3Screen');
  };

  return (
    <InternalTemplate
      title={'salesman-add-client-documents-title'}
      childContainerStyle={styles.childContainerStyle}
      backButton={{
        label: 'go-back',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}
      contentPaddingX="0">
      <LogisticForm onSubmit={handleOnSubmit} />
    </InternalTemplate>
  );
};

const styles = StyleSheet.create({
  childContainerStyle: {
    paddingBottom: '100%',
  },
});
